export class StoryTag {
  public id: string;
  public name: string;

  constructor(data: Partial<StoryTag> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: Partial<StoryTag> = {}): StoryTag {
    return new StoryTag(data);
  }
}
